/**
 * Country-aware payout/bank fields. Different countries settle differently:
 *   Iran        → Sheba (IR…) + optional card number
 *   IBAN region → IBAN + account holder
 *   US/others   → account number + routing
 * `method` drives which fields the dashboard renders.
 */
export const PAYOUT_COUNTRIES = [
  { code: 'IR', name: 'Iran',          flag: '🇮🇷', method: 'sheba' },
  { code: 'DE', name: 'Germany',       flag: '🇩🇪', method: 'iban' },
  { code: 'FR', name: 'France',        flag: '🇫🇷', method: 'iban' },
  { code: 'AE', name: 'UAE',           flag: '🇦🇪', method: 'iban' },
  { code: 'TR', name: 'Türkiye',       flag: '🇹🇷', method: 'iban' },
  { code: 'GB', name: 'United Kingdom',flag: '🇬🇧', method: 'iban' },
  { code: 'US', name: 'United States', flag: '🇺🇸', method: 'account' },
  { code: 'OTHER', name: 'Other',      flag: '🌐', method: 'iban' },
];

export function methodForCountry(code) {
  return (PAYOUT_COUNTRIES.find(c => c.code === code) || {}).method || 'iban';
}

// Fields per method: { key, label, placeholder, ltr }
export const PAYOUT_FIELDS = {
  sheba: [
    { key: 'accountHolder', label: 'Account holder name', placeholder: 'Full name on the account' },
    { key: 'iban',          label: 'Sheba number (شماره شبا)', placeholder: 'IR00 0000 0000 0000 0000 0000 00', ltr: true, prefix: 'IR' },
    { key: 'cardNumber',    label: 'Card number (شماره کارت) — optional', placeholder: '6037 9900 0000 0000', ltr: true },
    { key: 'bankName',      label: 'Bank name', placeholder: 'e.g. Bank Mellat' },
  ],
  iban: [
    { key: 'accountHolder', label: 'Account holder name', placeholder: 'Full name on the account' },
    { key: 'iban',          label: 'IBAN', placeholder: 'DE00 0000 0000 0000 0000 00', ltr: true },
    { key: 'bankName',      label: 'Bank name', placeholder: 'Your bank' },
  ],
  account: [
    { key: 'accountHolder', label: 'Account holder name', placeholder: 'Full name on the account' },
    { key: 'accountNumber', label: 'Account number', placeholder: '000123456789', ltr: true },
    { key: 'routingNumber', label: 'Routing number', placeholder: '021000021', ltr: true },
    { key: 'bankName',      label: 'Bank name', placeholder: 'Your bank' },
  ],
};
